import { logger } from '@parrot-software/observability';

import type { ISubscriptionBlockApiPort } from '@subscriptions/application/ports';
import type { CreateSubscriptionBlockDto, SubscriptionBlockViewDto } from '@subscriptions/application/dtos';
import { mapSubscriptionBlockToViewDto } from '@subscriptions/application/mappers';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const subLog = logger.forDomain('SUB', { subdomain: 'lifecycle' });

/**
 * Use case for creating a new subscription block.
 *
 * @param port - Subscription block API port
 * @returns Use case executor
 */
export const createSubscriptionBlockUseCase = (port: ISubscriptionBlockApiPort) => {
  const execute = async (dto: CreateSubscriptionBlockDto): Promise<SubscriptionBlockViewDto> => {
    try {
      const block = await port.create(dto);
      const view = mapSubscriptionBlockToViewDto(block);
      subLog.info('createSubscriptionBlock', {
        'block.uuid': view.uuid,
        'block.storeCount': view.stores?.length ?? 0,
      });
      return view;
    } catch (error) {
      subLog.error('createSubscriptionBlock', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
